import React, { Component } from 'react'
import { Container, BoxCard, ContainerTips } from './styles.style'
import PopupCard from '../popup-card/popup-card.component'
import MuviCardZone from '../muvicard-zone/muvicard-zone.component'
import StepsImg from '../../../../../assets/images/banners-cartao/steps.png'
import StepsImgMobile from '../../../../../assets/images/banners-cartao/steps-mobile.png'
import { isMobile } from '../../../../helpers'
import { CancelButton } from '../../../muvicard-cancel/components/cancel-button/cancel-button.component'

class ContentCard extends Component {
	render() {
		const { logged, isCancelPage, toastSuccess, toastError } = this.props
		return (
			<Container>
				<BoxCard className="box-card">
					<ContainerTips className="container-tips">
						{!isMobile() ? (
							<img src={`${StepsImg}`} alt="" className="-desk" />
						) : (
							<img src={`${StepsImgMobile}`} alt="" className="-desk" />
						)}
						{isCancelPage && (
							<CancelButton
								toastSuccess={toastSuccess}
								toastError={toastError}
							/>
						)}
					</ContainerTips>
					<PopupCard logged={logged} />
				</BoxCard>
				<MuviCardZone logged={logged} />
			</Container>
		)
	}
}

export default ContentCard
